/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Breadcrumb/view.blocks to change it.
import Documents from './Documents/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Breadcrumb({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Breadcrumb"
  
}) {
  return (<React.Fragment
>
<Documents
  viewPath={`${viewPath}/Documents`}
/>
{children}
</React.Fragment>)
}